module.exports = __webpack_public_path__ + "caa1b47dde023ebac5e93a931cc4b484.svg";